import React, { useRef, useEffect } from "react";
import { ArrowIcon, CollapseIcon, ExpandIcon } from "../../Assets/assets";
import { isValidArray } from "../../Services/validators";
import { getValidColorForStatus } from "../../Utils/Constants/Constants";
import Button from "../Button/Button";
import "./Table.css";

export default function Table(props) {
  const tableRef = useRef(null);

  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [props.currentPage]);

  return (
    <div className="inherit-parent-width inherit-parent-height">
      <div className="inherit-parent-width display-flex flex-justify-content-space-between padding-bottom-large">
        {props.title && (
          <div className="font-color-tertiaryColor6">{props.title}</div>
        )}
        {props.allowCollapse && (
          <div
            data-cy={!props.collapse ? "EXPAND-TABLE" : "COLLAPSE-TABLE"}
            className="display-flex flex-align-items-center cursor-pointer font-color-tertiaryColor6"
            onClick={() => {
              props.setCollapse(!props.collapse);
            }}
          >
            <div
              style={{
                width: "16px",
                height: "16px"
              }}
              className="margin-right-default"
            >
              {props.collapse ? (
                <CollapseIcon color="var(--tertiaryColor6)" />
              ) : (
                <ExpandIcon color="var(--tertiaryColor6)" />
              )}
            </div>
            <div className="font-size-small">
              {props.collapse ? "COLLAPSE" : "EXPAND"}
            </div>
          </div>
        )}
      </div>
      <div
        ref={tableRef}
        className={`inherit-parent-width ${
          !props.collapse ? "" : "overflow-scroll"
        }`}
        data-cy="TABLE"
        style={{
          height: props.collapse ? `calc(100% - 66px)` : "fit-content"
        }}
      >
        {isValidArray(props.data) && (
          <table
            className="inherit-parent-width"
            style={{
              borderCollapse: "collapse",
              tableLayout: "fixed"
            }}
          >
            <colgroup>
              {props.headers?.map((data, index) => (
                <col key={index} style={{ ...data }} />
              ))}
            </colgroup>
            <thead
              className="inherit-parent-width"
              style={{ borderBottom: "1px solid var(--tertiaryColor3)" }}
            >
              <tr
                style={{ position: "sticky", top: "0", zIndex: "100" }}
                className={`${props.backgroundColor} white-space-nowrap margin-bottom-larger`}
              >
                {props.headers?.map((header, index) => (
                  <th
                    className={`font-size-small ${
                      props.backgroundColor
                    } font-weight-normal ${
                      props.collapse ? "cursor-pointer" : ""
                    } margin-bottom-default`}
                    key={index}
                    onClick={() => {
                      if (
                        typeof props.handleSort === "function" &&
                        header.title !== "SI.No"
                      ) {
                        props.handleSort(header.title);
                      }
                    }}
                    data-cy={`TABLE-HEADER-${header?.title
                      ?.toString()
                      .toUpperCase()}`}
                    // style={{pointerEvents: props.collapse ? "none" : "auto"}}
                  >
                    <div
                      className={`table-header-border margin-default display-flex flex-align-items-center`}
                      style={
                        header.textAlign === "right"
                          ? {
                              justifyContent: "flex-end"
                            }
                          : {}
                      }
                    >
                      <div className="padding-right-default font-color-tertiaryColor5">
                        {header?.title}
                      </div>

                      {!props.disableSorting && (
                        <>
                          {props.sort?.title !== header?.title && (
                            <div style={{ padding: "6px" }} />
                          )}

                          {props.sort?.title === header?.title &&
                            props.sort?.ascending === true && (
                              <div
                                style={{
                                  transform: "rotate(180deg)"
                                }}
                                data-cy={`${header?.title}-ASCENDING-SORT`}
                                className="height-fit-content width-fit-content"
                              >
                                <SortIcon color="var(--tertiaryColor5)" />
                              </div>
                            )}

                          {props.sort?.title === header?.title &&
                            props.sort?.ascending === false && (
                              <div
                                data-cy={`${header?.title}-DESCENDING-SORT`}
                                className="height-fit-content width-fit-content flex-align-items-center"
                              >
                                <SortIcon color="var(--tertiaryColor5)" />
                              </div>
                            )}
                        </>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className="font-color-tertiaryColor font-size-small inherit-parent-width margin-top-small">
              {props.data?.map((data, index) => (
                <tr
                  key={index}
                  data-cy={`${data?.documentId}-card`}
                  id={data?.documentId}
                >
                  {isValidArray(props.headers) &&
                    props.headers?.map((header, i) => (
                      <td
                        key={i}
                        style={{ ...header }}
                        className="inherit-parent-width"
                      >
                        <div
                          className={`inherit-parent-height inherit-parent-width padding-top-medium padding-medium text-overflow-ellipsis ${
                            typeof props?.onClick === "function"
                              ? "cursor-pointer"
                              : ""
                          }`}
                          onClick={() => {
                            if (typeof props?.onClick === "function") {
                              props.onClick(data);
                            }
                          }}
                          data-cy={`${data.documentId}-${
                            header?.title
                          }-${data?.[props.getField(header?.title)] || "N/A"}`}
                        >
                          {header.title === "STATUS" && props.color && (
                            <div
                              className={`inherit-parent-height inherit-parent-width flex-align-items-center flex-justify-content-center cursor-pointer text-overflow-ellipsis`}
                              data-cy={`${data.documentId}-STATUS-${data?.status}`}
                            >
                              <div
                                style={{
                                  width: "14px",
                                  height: "14px"
                                }}
                                className={`border-radius-100-percentage ${getValidColorForStatus(
                                  data?.status
                                )}`}
                              />
                            </div>
                          )}

                          {header.title === "LAST EMP. CAP." && props.color && (
                            <div
                              className={`inherit-parent-height inherit-parent-width flex-align-items-center flex-justify-content-center cursor-pointer text-overflow-ellipsis`}
                              data-cy={`${data.documentId}-LAST EMP. CAP.-${data.totalManPowerCapacity}`}
                            >
                              <div
                                style={
                                  data?.totalManPowerCapacity !== "N/A"
                                    ? {
                                        width: "14px",
                                        height: "14px"
                                      }
                                    : {}
                                }
                                className={`border-radius-100-percentage ${
                                  data?.totalManPowerCapacity !== "N/A"
                                    ? data?.totalManPowerCapacity
                                      ? "background-color-green"
                                      : "background-color-red"
                                    : ""
                                }`}
                              />
                              {data?.totalManPowerCapacity === "N/A" && "N/A"}
                            </div>
                          )}

                          {header.title === "ATTENDANCE" && (
                            <div
                              className={`inherit-parent-height inherit-parent-width flex-align-items-center flex-justify-content-center cursor-pointer text-overflow-ellipsis`}
                              data-cy={`${data.documentId}-ATTENDANCE-${data.attendance}`}
                            >
                              {data?.attendance === null ? (
                                <div
                                  style={{ height: "12px" }}
                                  className="display-flex flex-justify-content-center flex-align-items-center"
                                >
                                  {props.theme === "dark" ? (
                                    <div className="dot-pulse" />
                                  ) : (
                                    <div className="dot-pulse-dark" />
                                  )}
                                </div>
                              ) : (
                                <>
                                  {data?.attendance === "N/A"
                                    ? "N/A"
                                    : `${data?.attendance} %`}
                                </>
                              )}
                            </div>
                          )}
                          {(header.title === "TURNAROUND TIME" ||
                            header.title === "SOURCE" ||
                            header.title === "NAME") && (
                            <>
                              {data?.[props.getField(header?.title)] || "N/A"}
                            </>
                          )}
                          {![
                            "ATTENDANCE",
                            "LAST EMP. CAP.",
                            "TURNAROUND TIME",
                            "SOURCE",
                            "NAME"
                          ].includes(header.title) &&
                            !props.color && (
                              <>
                                {data?.[props.getField(header?.title)]
                                  ?.toString()
                                  ?.toUpperCase() || "N/A"}
                              </>
                            )}
                        </div>
                      </td>
                    ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {!isValidArray(props.data) && (
          <div
            data-cy="NO-TABLE-DATA-FALL-BACK"
            className="inherit-parent-width inherit-parent-height flex-justify-content-space-between flex-direction-column"
          >
            <div>
              <table
                className="inherit-parent-width"
                style={{
                  borderCollapse: "collapse",
                  tableLayout: "fixed"
                }}
              >
                <colgroup>
                  {props.headers?.map((data, index) => (
                    <col key={index} style={{ ...data }} />
                  ))}
                </colgroup>
                <thead
                  className="inherit-parent-width"
                  style={{ borderBottom: "1px solid var(--tertiaryColor3)" }}
                >
                  <tr
                    style={{ position: "sticky", top: "0", zIndex: "100" }}
                    className={`${props.backgroundColor} white-space-nowrap margin-bottom-larger`}
                  >
                    {props.headers?.map((header, index) => (
                      <th
                        className={`font-size-small ${
                          props.backgroundColor
                        } font-weight-normal  ${
                          props.collapse ? "cursor-pointer" : ""
                        }  margin-bottom-default`}
                        key={index}
                        onClick={() => {
                          if (
                            typeof props.handleSort === "function" &&
                            header.title !== "SI.No" &&
                            props.collapse
                          ) {
                            props.handleSort(header.title);
                          }
                        }}
                        data-cy={`TABLE-HEADER-${header?.title
                          ?.toString()
                          .toUpperCase()}`}
                      >
                        <div
                          className={`table-header-border padding-medium display-flex`}
                        >
                          <div className="padding-right-default font-color-tertiaryColor5">
                            {header?.title}
                          </div>

                          <>
                            {props.sort?.title === header?.title &&
                              props.sort?.ascending === true && (
                                <div
                                  style={{
                                    transform: "rotate(180deg)"
                                  }}
                                  data-cy={`${header?.title}-ASCENDING-SORT`}
                                  className="height-fit-content width-fit-content"
                                >
                                  <SortIcon color="var(--tertiaryColor5)" />
                                </div>
                              )}

                            {props.sort?.title === header?.title &&
                              props.sort?.ascending === false && (
                                <div
                                  data-cy={`${header?.title}-DESCENDING-SORT`}
                                  className="height-fit-content width-fit-content flex-align-items-center"
                                >
                                  <SortIcon color="var(--tertiaryColor5)" />
                                </div>
                              )}
                          </>
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
              </table>
            </div>
            <div>
              <NoMatchingResultsFallback
                resetAllClick={props.resetAllClick}
                collapse={props.collapse}
              />
            </div>
            <div
              style={{
                padding: "8px"
              }}
            />
          </div>
        )}
      </div>
      {props.collapse && (
        <div className="inherit-parent-width padding-top-large">
          <Paginator
            totalPage={props.totalPage || 1}
            currentPage={props.currentPage || 1}
            previousPageOnClick={props.previousPageOnClick}
            nextPageOnClick={props.nextPageOnClick}
          />
        </div>
      )}
    </div>
  );
}

const SortIcon = (props) => {
  return (
    <div>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path
          d="M6.00006 9.11454L6.00006 2.44788"
          stroke={props.color || "white"}
          strokeLinecap="round"
        />
        <path
          d="M6.00006 9.55207L8.77784 6.77429"
          stroke={props.color || "white"}
          strokeLinecap="round"
        />
        <path
          d="M6.00001 9.55207L3.22223 6.77429"
          stroke={props.color || "white"}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

const NoMatchingResultsFallback = (props) => {
  return (
    <div
      style={!props.collapse ? { paddingTop: "64px" } : {}}
      className="inherit-parent-width inherit-parent-height display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
    >
      <div className="inherit-parent-width white-space-nowrap font-color-tertiaryColor font-size-larger flex-justify-content-center">
        No results found
      </div>
      <div className="white-space-nowrap font-size-small padding-top-default font-color-tertiaryColor6">
        TRY DIFFERENT FILTER, SEARCH TERM, OR
      </div>
      <div
        style={{
          width: "150px"
        }}
        className="padding-top-medium"
      >
        <Button
          boxShadow={false}
          onClick={props.resetAllClick}
          text="Reset All"
          variant="danger"
        />
      </div>
    </div>
  );
};

const Paginator = (props) => {
  return (
    <div
      data-cy="TABLE-PAGINATOR"
      className="display-flex inherit-parent-width flex-justify-content-center"
    >
      <div>
        <div
          data-cy="PAGINATION-NEGATIVE"
          className={`${
            props.currentPage <= props.totalPage && props.currentPage > 1
              ? "cursor-pointer"
              : "cursor-no-drop"
          }`}
          onClick={() => {
            if (props.currentPage <= props.totalPage && props.currentPage > 1) {
              props.previousPageOnClick();
            }
          }}
          style={{
            transform: "rotate(90deg)",
            height: "16px",
            width: "16px"
          }}
        >
          <ArrowIcon
            color={
              props.currentPage <= props.totalPage && props.currentPage > 1
                ? "var(--tertiaryColor6)"
                : "var(--tertiaryColor5)"
            }
          />
        </div>
      </div>

      <div className="display-flex font-size-small padding-left-larger padding-right-larger">
        <div className="padding-right-default font-color-tertiaryColor6">
          PAGE
        </div>
        <div
          data-cy={`PAGINATION-CURRENT-PAGE-${props.currentPage}`}
          className="font-color-tertiaryColor"
        >
          {props.currentPage} of {props.totalPage}
        </div>
      </div>

      <div>
        <div
          data-cy="PAGINATION-POSITIVE"
          className={`${
            props.currentPage < props.totalPage
              ? "cursor-pointer"
              : "cursor-no-drop"
          }`}
          onClick={() => {
            if (props.currentPage < props.totalPage) {
              props.nextPageOnClick();
            }
          }}
          style={{
            transform: "rotate(-90deg)",
            height: "16px",
            width: "16px"
          }}
        >
          <ArrowIcon
            color={
              props.currentPage < props.totalPage
                ? "var(--tertiaryColor6)"
                : "var(--tertiaryColor5)"
            }
          />
        </div>
      </div>
    </div>
  );
};
